<div class="gopher-wrapper gopher-main">
	<div class="banner">
		<div class="text">
			Gopher is a chaos engineering platform, built to run safe, secure and simple chaos experiments on software system.
		</div>
		<div class="img">
			<img src="/assets/images/gopher/Gopher-Logo.png" alt="Gopher" />
		</div>
	</div>

	<div class="container-fluid main-sub">
		<div class="live-sec">
			<div class="sec-title">Capabilities</div>
			<div class="sub-line">Live</div>
			<div class="row">
				<div class="col-md-3 col-xs-12">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/cpu.png" alt="CPU">CPU
						</div>
						<div class="text relay-margin-top-10">Overload CPU cores to test how system works with limited computation capabilities.</div>
					</div>
				</div>
				<div class="col-md-3  col-xs-12">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/shutdown.png" alt="Shutdown">Shutdown
						</div>
						<div class="text relay-margin-top-10">Halt/reboot a machine.</div>
					</div>
				</div>
				<div class="col-md-3 col-xs-12">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/memory.png" alt="Memory">Memory
						</div>
						<div class="text relay-margin-top-10">Consuming specific amount of memory.</div>
					</div>
				</div>
				<div class="col-md-3 col-xs-12">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/disk.png" alt="Disk">Disk
						</div>
						<div class="text relay-margin-top-10">Consuming disk space.</div>
					</div>
				</div>
			</div>
			<div class="get-started-button">
				<a [routerLink]="['client']">GET STARTED</a>
			</div>
		</div>
		<div class="soon-sec">
			<div class="sub-line second">Coming soon</div>
			<div class="row">
				<div class="col-md-2">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/blackhole.png" alt="Blackhole">Blackhole
						</div>
						<div class="text relay-margin-top-10">Dropping all the traffic coming to the machine(TCP/UDP)</div>
					</div>
				</div>
				<div class="col-md-2">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/latency.png" alt="Latency">Latency
						</div>
						<div class="text relay-margin-top-10">Introducing delay for specified packets</div>
					</div>
				</div>
				<div class="col-md-2">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/io.png" alt="I/O">I/O
						</div>
						<div class="text relay-margin-top-10">Continuously synchronising filesystem to disk to put read/ write pressure on the disk.</div>
					</div>
				</div>
				<div class="col-md-2">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/dns.png" alt="DNS">DNS
						</div>
						<div class="text relay-margin-top-10">Blocking access to DNS servers</div>
					</div>
				</div>
				<div class="col-md-2">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/packet-loss.png" alt="Packet Loss">Packet Loss
						</div>
						<div class="text relay-margin-top-10">Losing some of the specified packets randomly</div>
					</div>
				</div>
				<div class="col-md-2">
					<div class="sub-body">
						<div class="title">
							<img src="/assets/images/gopher/kill.png" alt="Process Kill">Process Kill
						</div>
						<div class="text relay-margin-top-10">Kill a specific process</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</div>
